import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListEmspUserIdCell } from './emsp-bo-charging-session-list-emsp-user-id.cell';
import { EmspBoChargingSessionListEmspUserIdHeader } from './emsp-bo-charging-session-list-emsp-user-id.header';

export const EmspBoChargingSessionListEmspUserIdColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['emspUser']['id']
> = {
  id: 'emspUserId',
  enableSorting: false,
  header: EmspBoChargingSessionListEmspUserIdHeader,
  cell: EmspBoChargingSessionListEmspUserIdCell,
};
